export enum CountryCode {
    Lithuania = 'lt',
    Latvia = 'lv',
    Estonia = 'ee',
}
